import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=c6675cf6&scoped=true&lang=pug&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=c6675cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6675cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6675cf6')) {
      api.createRecord('c6675cf6', component.options)
    } else {
      api.reload('c6675cf6', component.options)
    }
    module.hot.accept("./NewUser.vue?vue&type=template&id=c6675cf6&scoped=true&lang=pug&", function () {
      api.rerender('c6675cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/NewUser.vue"
export default component.exports